__turbopack_context__.v({
  "show_poster__badge": "nhmUXq_show_poster__badge",
  "show_poster__compass_rose": "nhmUXq_show_poster__compass_rose",
  "show_poster__fallback": "nhmUXq_show_poster__fallback",
  "show_poster__link": "nhmUXq_show_poster__link",
  "splide__list": "nhmUXq_splide__list",
});
